module.exports = __webpack_public_path__ + "static/media/tiktok.7f26e1a2.png";